import create from "zustand";
import produce from "immer";
import { devtools, persist } from "zustand/middleware";

type WorkspaceAssistantEnabledState = {
  workspaceAssistantEnabled: boolean;
  setWorkspaceAssistantEnabled: (workspaceAssistantEnabled: boolean) => void;
};

const useWorkspaceAssistantEnabledStore =
  create<WorkspaceAssistantEnabledState>()(
    devtools(
      persist(
        (set) => ({
          workspaceAssistantEnabled: false,
          setWorkspaceAssistantEnabled: (workspaceAssistantEnabled) =>
            set(produce((state) => ({ ...state, workspaceAssistantEnabled }))),
        }),
        {
          name: "Workspace/WorkspaceAssistantEnabled",
        }
      )
    )
  );

export const useWorkspaceAssistantEnabled = () => {
  const { workspaceAssistantEnabled, setWorkspaceAssistantEnabled } =
    useWorkspaceAssistantEnabledStore();
  return [workspaceAssistantEnabled, setWorkspaceAssistantEnabled] as const;
};
